import React from "react";
import { Link } from "react-router-dom";
import { MapPin, Building2, BookOpenText, HandshakeIcon } from "lucide-react";

const ITEMS = [
  { id: "states", Icon: MapPin, label: "Licensed in select states — full list on our Compliance page", link: "/compliance#licenses" },
  { id: "independent", Icon: Building2, label: "Independent — multiple carriers" },
  { id: "education", Icon: BookOpenText, label: "Education-first approach" },
  { id: "no-pressure", Icon: HandshakeIcon, label: "No-pressure consultations" },
];

export const TrustBand = () => {
  return (
    <section
      id="why"
      data-testid="trust-band"
      className="relative py-14 sm:py-16 bg-lw-navy text-[#FAF8F3]"
    >
      <div
        aria-hidden="true"
        className="absolute inset-x-0 top-0 gold-hairline"
      />
      <div
        aria-hidden="true"
        className="absolute inset-x-0 bottom-0 gold-hairline"
      />
      <div className="max-w-7xl mx-auto px-5 sm:px-8 lg:px-12">
        <div className="text-center mb-10 reveal">
          <span
            className="lw-eyebrow"
            style={{ color: "#D4A24C" }}
          >
            Why Lifespan
          </span>
          <h2 className="mt-3 font-serif-display text-2xl sm:text-3xl lg:text-4xl text-[#FAF8F3]">
            A firm built around <span className="italic">your timeline</span>.
          </h2>
        </div>
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-6 lg:gap-8">
          {ITEMS.map(({ id, Icon, label }) => (
            <div
              key={id}
              data-testid={`trust-item-${id}`}
              className="flex flex-col items-center text-center"
            >
              <div className="w-12 h-12 rounded-full border border-lw-gold/40 flex items-center justify-center text-lw-gold">
                <Icon size={20} />
              </div>
              <p className="mt-4 font-sans-ui text-sm sm:text-base text-[#FAF8F3]/90 leading-snug max-w-[180px]">
                {label}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TrustBand;
